// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"referral-module--textBlock--26er2","btn":"referral-module--btn--1C4s_","tenPercents":"referral-module--tenPercents--qixX0"};